// components.
import { RowsActionsRemo } from "./components/RowsActionsRemo";

export const TableActionsRemo = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 165px)",
        overflowY: "auto",
      }}
    >
      <RowsActionsRemo />
    </div>
  );
};
